<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <div>
      <ik-data-table
        entity-name="BannerCarouselSettings"
        :model="model"
        :use-select="false"
        icon="mdi-developer-board"
      />
    </div>
  </div>
</template>

<script>
import NewBannerImage from '@/model/dataLayer/api/restaurant/NewBannerImage'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'

export default {
  components: {
    IkDataTable
  },
  data () {
    return {
      model: NewBannerImage
    }
  }
}
</script>

<style scoped>

</style>
